import PropTypes from "prop-types";
import * as React from "react";
import { ErrorBoundary as LibraryErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import { reportCrash } from "./reportCrash";

export default function ErrorBoundary({
  section,
  variant = "page",
  resetKeys,
  onReset,
  fallback,
  children,
}) {
  const handleError = React.useCallback(
    (error, { componentStack }) =>
      reportCrash({ error, componentStack, section }),
    [section],
  );

  const renderFallback = React.useCallback(
    (props) =>
      fallback === undefined ? (
        <ErrorFallback variant={variant} {...props} />
      ) : (
        fallback
      ),
    [fallback, variant],
  );

  return (
    <LibraryErrorBoundary
      fallbackRender={renderFallback}
      onError={handleError}
      onReset={onReset}
      resetKeys={resetKeys}
    >
      {children}
    </LibraryErrorBoundary>
  );
}

ErrorBoundary.propTypes = {
  section: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["page", "inline"]),
  resetKeys: PropTypes.array,
  onReset: PropTypes.func,
  fallback: PropTypes.node,
  children: PropTypes.node,
};
